export default {
  toolbar: {
    unlock: "Unlock invoice number",
    lock: "Lock invoice number",
    saveSettingsFirst: "Unsaved settings can not be locked",
  },

  general: {
    title: "General invoice settings",
    requires: {
      defaultCountry: {
        text: "Set a default country before you can change General invoice settings",
        button: "To system defaults"
      },
    },
    input: {
      defaultTax: "Default VAT",
      defaultTerm: "Default invoice term",
      termType: {
        day: "days",
        month: "months",
        week: "weeks",
      },
    },
  },

  invoiceNumber: {
    title: "Invoice number settings",
    input: {
      startNumber: "Start number",
      numberZeroes: {
        label: "Invoice number length",
        explain: "Number of zeroes to prepend the invoice number.",
      },
      format: {
        label: "Invoice number Format",
        explain: "Use special characters: month {m}, year {y}, full year {Y} invoice number {n}"
      },
      resetInvoiceNumberOn: {
        label: "Reset invoice number",
        yearly: "Yearly",
        monthly: "Monthly",
      },
    },
    text: {
      nextUp: "Next invoice number:",
    },
  },

  printTemplate: {
    title: "Invoice print templates",
    button: {
      activate: "Activate",
      example: "Example",
    }
  },

  button: {
    submit: "Opslaan",
  },

  api: {
    patch: {
      defaultSettings: {
        success: "General invoice settings saved.",
      },
      invoiceNumber: {
        success: "Invoice number settings saved."
      }
    },
  },
}
